import { CheckDocBottomMargin } from '@bingads-webui-campaign/recommendation-core';

/**
 * set postion of el to top if bottom space is not enough else set it at bottom
 * @param {object} $el - element
 * @returns {void}
 */
export function setPosition($el) {
  $el.css('top', '');
  $el.css('bottom', '');
  $el.css('margin-top', '');
  $el.css('margin-bottom', '');
  if (!CheckDocBottomMargin($el, 50)) {
    $el.css('bottom', '100%');
    $el.css('margin-bottom', '5px');
  } else {
    $el.css('top', '100%');
    $el.css('margin-top', '5px');
  }
}
